import { useParams } from 'react-router-dom';
import { useUrlParams } from '../../../hooks/useUrlParams';
import { query } from '../../../util/api/query';
import type { PromotionProductDto } from '../types/PromotionDto';
import type { Pagination } from '../../../hooks/usePagination';

export function useSelectedProductsQuery(
	branchId: string,
	promotionId: string,
	isOpened: boolean,
) {
	const { organisation } = useParams();

	const selectedProductsParams = useUrlParams({
		branchId,
		promotionId,
	});

	const selectedProductsQuery = query<PromotionProductDto[]>(
		`${organisation}/promotions/products-by-promotion?${selectedProductsParams}`,
		isOpened,
	);

	return selectedProductsQuery;
}

export function useAvailableProductsQuery(
	branchId: string,
	isOpened: boolean,
	pagination: Pagination,
	searchParam: string,
) {
	const { organisation } = useParams();

	const productOptionsParams = useUrlParams({
		branchId,
		size: pagination.pageSize,
		number: pagination.pageNumber,
		searchQuery: searchParam,
	});

	const availableProductsQuery = query<PromotionProductDto[]>(
		`${organisation}/promotions/products-by-branch?${productOptionsParams}`,
		isOpened,
	);

	const availableProductsCountQuery = query<number>(
		`${organisation}/promotions/products-by-branch-count?branchId=${branchId}${searchParam.length > 0 ? `&searchQuery=${searchParam}` : ''}`,
		isOpened,
	);

	return {
		availableProductsQuery,
		availableProductsCountQuery,
	};
}
